import type { BadgeTone } from '@/components/ui/status-tone'
import type { OtsSyncStatus } from '@/types/api'

/** Statuses in which the trip belongs on the driver's app. */
export const LIVE_STATUSES = new Set(['CONFIRMED', 'ON_THE_WAY', 'ARRIVED', 'STARTED'])

/** The trip's status as the OTS app holds it. */
export const OTS_STATUS_LABELS: Record<number, string> = {
  [-5]: 'Draft',
  [-1]: 'Cancelled',
  0: 'Assigned',
  1: 'Ongoing',
  2: 'Ended',
}

export interface Verdict {
  tone: BadgeTone
  label: string
}

/** One badge for where the trip stands on the driver app. */
export function driverAppVerdict(sync: OtsSyncStatus | null): Verdict {
  if (!sync) return { tone: 'neutral', label: 'Not on the driver app' }
  switch (sync.state) {
    case 'SYNCED':
      return sync.outstanding
        ? { tone: 'warning', label: 'Update waiting' }
        : { tone: 'success', label: 'On the driver app' }
    case 'PENDING':
      return sync.attempts > 0 ? { tone: 'warning', label: 'Retrying' } : { tone: 'warning', label: 'Queued' }
    case 'PROCESSING':
      return { tone: 'info', label: 'Sending' }
    case 'FAILED':
      return { tone: 'danger', label: 'Not delivered' }
    default:
      return { tone: 'neutral', label: 'Unknown' }
  }
}
